
  import {defineComponent} from "vue";
  import {mapState} from "vuex";
  import router from "@/router";
  import store from "@/store";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  export default defineComponent({
    name: "order-button-component",
    methods: {
      moveToPurchasePage(): void {
        // 내 번호를 알아낼 방법
        // 로그인 되어있다면, api로 호출해서 내 번호를 저장
        // 비로그인 되어있다면, 휴대폰 인증화면으로 이동
        if (this.isAuthenticated) {
          router.push(new NamedRouting('MessageWritingForPurchase'));
        } else {
          store.commit('NextViewStore/setNextView', new NamedRouting('MessageWritingForPurchase'));
          this.$emit('openAuthenticationPromptPopup');
        }
      },
      moveToPresentPage():void{
        if (this.isAuthenticated) {
          router.push(new NamedRouting('ReceiverSelection'));
        } else {
          store.commit('NextViewStore/setNextView', new NamedRouting('ReceiverSelection'));
          this.$emit('openAuthenticationPromptPopup');
        }
      }
    },
    computed: {
      isSoldout(): boolean {
        return !this.product.isPurchasable;
      },
      classForPurchaseButton(): Record<string, boolean> {
        return {
          btn_default: this.product.isGiftable,
          btn_buy: !this.product.isGiftable
        }
      },
      isAuthenticated(): boolean{
        return this.token !== undefined || this.phoneNumber !== undefined;
      },
      ...mapState({
        product: (state: any) => state.ProductStore.product,
        token: (state: any) => state.MemberStore.token,
        phoneNumber: (state: any) => state.MemberStore.phoneNumber,
      }),
    }
  });
